export enum UniformItemColors {
  Primary = "primary",
  Secondary = "secondary",
  Tertiary = "tertiary",
  Lettering = "lettering",
}
